(function () {
  function init() {
    var btn = document.querySelector('[data-back-to-top]');
    if (!btn) return;

    var showAfterPx = 380;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function updateVisibility() {
      var y = window.scrollY || document.documentElement.scrollTop;
      btn.classList.toggle('is-visible', y > showAfterPx);
    }

    updateVisibility();
    window.addEventListener('scroll', updateVisibility, { passive: true });

    btn.addEventListener('click', function () {
      window.scrollTo({
        top: 0,
        behavior: reduceMotion ? 'auto' : 'smooth'
      });
      var main = document.getElementById('content');
      if (main && typeof main.focus === 'function') {
        if (!main.hasAttribute('tabindex')) main.setAttribute('tabindex', '-1');
        main.focus({ preventScroll: true });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
